import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, PlaneIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-navy-900 overflow-hidden" data-id="element-122">
      {/* Gold accent line at top */}
      <div className="absolute inset-0 opacity-5" data-id="element-123">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
        backgroundSize: '40px 40px'
      }} data-id="element-124" />
      </div>

      <div className="w-full h-1 bg-gradient-to-r from-transparent via-gold-500 to-transparent" data-id="element-125" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24" data-id="element-126">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-127">
          {/* Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: 'easeOut'
        }} data-id="element-128">
            <div className="flex items-center gap-2 mb-6" data-id="element-129">
              <PlaneIcon className="w-5 h-5 text-gold-500" aria-hidden="true" data-id="element-130" />
              <span className="text-gold-500 font-body text-sm font-semibold tracking-widest uppercase" data-id="element-131">
                Protocolo Operativo
              </span>
            </div>

            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-132">
              El Protocolo de Aterrizaje:{' '}
              <span className="text-gold-500" data-id="element-133">Misión USA 30 Días</span>
            </h1>

            <p className="font-body text-lg sm:text-xl text-navy-100 leading-relaxed mb-8 max-w-xl" data-id="element-134">
              La hoja de ruta operativa para familias con visa aprobada que
              necesitan aterrizar con orden, seguridad y sin quemar sus ahorros
              en errores de principiante.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-135">
              <a href="#oferta-precio" className="inline-flex items-center justify-center px-8 py-4 bg-gold-500 text-navy-900 font-body font-bold text-lg rounded-lg hover:bg-gold-400 transition-colors duration-200 shadow-lg shadow-gold-500/20" data-id="element-136">
                Descargar el Protocolo Ahora
              </a>
              <a href="#que-incluye" className="inline-flex items-center justify-center px-8 py-4 border-2 border-navy-300 text-white font-body font-semibold text-lg rounded-lg hover:border-gold-500 hover:text-gold-500 transition-colors duration-200" data-id="element-137">
                Ver qué incluye
              </a>
            </div>

            <div className="flex items-center gap-3 text-navy-200 font-body text-sm" data-id="element-138">
              <ShieldCheckIcon className="w-5 h-5 text-gold-500 flex-shrink-0" aria-hidden="true" data-id="element-139" />
              <span data-id="element-140">Acceso inmediato y seguro · Pago único de $6.36 USD</span>
            </div>
          </motion.div>

          {/* Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2,
          ease: 'easeOut'
        }} className="flex justify-center lg:justify-end" data-id="element-141">
            <div className="relative" data-id="element-142">
              {/* Glow behind image */}
              <div className="absolute -inset-4 bg-gold-500/10 rounded-3xl blur-2xl" data-id="element-143" />
              <img src="https://cdn.magicpatterns.com/uploads/iwzKAb4P3aKbazzvx3NpLZ/El_Protocolo_de_Aterrizaje_de_30_Dias.png" alt="El Protocolo de Aterrizaje: Misión USA 30 Días — vista previa del e-book en tablet" className="relative w-full max-w-md rounded-2xl shadow-2xl" data-id="element-144" />
            </div>
          </motion.div>
        </div>
      </div>

      {/* Bottom gold accent */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-gold-500/40 to-transparent" data-id="element-145" />
    </section>;
}